import React from 'react';
import { Transaction, CompanyInfo } from '../types';
import { Printer, X } from 'lucide-react';
import { printContent } from '../utils/print';
import { getTransactionReceiptHtml } from '../utils/printTemplates';

interface TransactionReceiptProps {
  transaction: Transaction;
  companyInfo: CompanyInfo | null;
  onClose: () => void;
}

const TransactionReceipt: React.FC<TransactionReceiptProps> = ({ transaction, companyInfo, onClose }) => {
  const isIncome = transaction.type === 'Income';

  const handlePrint = () => {
    const html = getTransactionReceiptHtml(transaction, companyInfo);
    printContent(`سند ${isIncome ? 'قبض' : 'صرف'} - ${transaction.id}`, html);
  };

  return (
    <div 
      className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fadeIn"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white w-full max-w-2xl shadow-2xl relative flex flex-col rounded-2xl overflow-hidden max-h-[90vh]">
        
        {/* Actions bar (UI only) */}
        <div className="p-4 bg-slate-50 border-b border-slate-200 flex justify-between items-center shrink-0 print:hidden">
          <button 
            onClick={handlePrint}
            className="px-5 py-2.5 bg-slate-950 text-white rounded-xl font-bold flex items-center gap-2 hover:bg-slate-800 transition-all active:scale-95 text-sm shadow-md"
          >
            <Printer size={16} />
            <span>طباعة السند</span>
          </button>
          <div className="font-bold text-slate-800 text-sm">عرض سند {isIncome ? 'القبض (إيراد)' : 'الصرف (مصروف)'}</div>
          <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors active:scale-90">
             <X size={20} className="text-slate-400" />
          </button>
        </div>

        {/* Scrollable print area */}
        <div className="flex-1 overflow-y-auto p-6 sm:p-8 custom-scrollbar print:p-0 bg-slate-100/30 print:bg-white">
          <div 
            className="max-w-2xl mx-auto shadow-sm border border-slate-200 rounded-xl overflow-hidden print:border-0 print:shadow-none"
            dangerouslySetInnerHTML={{ __html: getTransactionReceiptHtml(transaction, companyInfo) }}
          />
        </div>
      </div>
    </div>
  );
};

export default TransactionReceipt;
